let __DEV__ = false;

try {
  __DEV__ = process.env.NODE_ENV !== 'production';
} catch (e) {
  console.log(e);
}

const createReducer = (initialState, handlers) => {
  if (__DEV__ && handlers.undefined) {
    console.warn(
      "Reducer contains an 'undefined' action type. " +
        'Have you misspelled a constant?',
    );
  }

  return function reducer(state, action) {
    if (state === undefined) state = initialState; // eslint-disable-line no-param-reassign

    if (handlers.hasOwnProperty(action.type)) {
      // eslint-disable-line no-prototype-builtins
      return handlers[action.type](state, action.payload);
    }
    return state;
  };
};

export default createReducer;
